import React from 'react'
import LoaderButton from '../../components/LoaderButton'
import FormViewer from '../../components/FormViewer'
import { chooseWallpaper, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';


class CHIntroduction extends React.Component {
    state = {
        display: true,
    }

    componentDidMount() {

        this.props.showHeader(false, () => {


        })


    }

    componentWillUnmount() {
    }

    toggleDisplay = () => {
        this.setState(prevState => ({
            display: !prevState.display
        }))
    }



    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextClicked}
                    isLoading={this.state.isLoading}
                    title={translate("Next Step")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }


    render() {
        return (

            <div className=" w-100 h-100 scroll-no-scrollbar window-content-radius position-relative" style={{}}>
                <div className='w-100 h-100 position-absolute overflow-hidden'>
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgb(255 51 124 / 15%) 0%, rgba(245, 228, 255, 0) 100%)' }}></div>
                    <div className='animated-bg' style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgb(51 231 255 / 8%) 0%, rgba(245, 228, 255, 0) 100%)' }}></div>
                </div>
                <div className='flexcc flex-column w-100 h-100'>
                    <Responsive width={this.props.width} media={{ xs: "12", md: '12' }}>
                        <div className=' w-100 flexc flex-column position-relative'>
                            <div>
                                <div>
                                    <img className='position-absolute rotate-img' style={{ top: -95, width: 180, left: -52, opacity: .4 }} src="/assets/icons/portals/Asset 2.svg" />

                                </div>
                                <h2 className="mt-2 text-big mb-0 color-dark-blue-1 " >{translate('Create Hub')}</h2>
                                <div style={{ maxWidth: 450 }}>
                                    <p className="mt-1 text-small color-dark-blue-1 " >{translate('What is a hub? Lorem ipsum dolor sit amet consectetur, adipisicing elit. Incidunt iure mollitia illo et, id deleniti magnam necessitatibus. Expedita ad, numquam voluptatum autem atque dignissimos laboriosam. Culpa enim quod maxime asperiores.')}</p>
                                </div>
                                <div className='mt-3 d-flex' style={{ justifyContent: "end" }}>
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={this.props.nextStage}
                                        title={translate("Let's Start")}
                                        icon='/assets/icons/angle-right-white2.svg'
                                        textColor={'#fff'}
                                        bg={'linear-gradient(90deg, rgb(205, 100, 254), rgb(254, 100, 129))'}
                                    // bg={'linear-gradient(to right, #FF9D5E, #FE6481)'}
                                    />
                                </div>

                            </div>
                        </div>
                    </Responsive>
                    {/* <div className=' mx-5 br-15' style={{ maxWidth: 469 }}>
                        <div className='p-2 mt-2'>
                            <div className='flexcb w-100'>
                                <h2 className=" font-size-20 mb-0 color-dark-blue-1 " style={{}} >{translate('Intro and Features')}</h2>
                            </div>
                            <div className='' style={{}}>
                                <p className="mt-1 text-small color-dark-blue-1" >{translate('What is a hub? Lorem ipsum dolor sit amet consectetur, adipisicing elit. Incidunt iure mollitia illo et, id deleniti magnam necessitatibus. Expedita ad, numquam voluptatum autem atque dignissimos laboriosam. Culpa enim quod maxime asperiores.')}</p>
                            </div>
                        </div>
                    </div> */}

                    {/* <Responsive width={this.props.width} height="100%" media={{ xs: "none", md: '4', lg: "6", xl: "6" }}>
                        <div className=' w-100 h-100 d-flex position-relative' >
                            <div className='p-3 br-15' style={{ backgroundColor: '#ffffffee', borderRadius: 8, flex: 1, boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}>
                                <h2 className=" text-big mb-0" >{translate('Intro and Features')}</h2>
                                <p className="mt-1 text-small" >{translate('What is a hub? Lorem ipsum dolor sit amet consectetur, adipisicing elit. Incidunt iure mollitia illo et, id deleniti magnam necessitatibus. Expedita ad, numquam voluptatum autem atque dignissimos laboriosam. Culpa enim quod maxime asperiores.')}</p>
                            </div>
                        </div>
                    </Responsive> */}
                </div>

            </div>

        )
    }
}

export default CHIntroduction;